import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=24686438&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=ts&"
export * from "./activity.vue?vue&type=script&lang=ts&"
import style0 from "./activity.vue?vue&type=style&index=0&id=24686438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24686438",
  null
  
)

export default component.exports